export function formatFurnished(f: string): string {
  return f
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join('-');
}

export function extractPostcode(address: string): string {
  const match = address.match(/[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d?[A-Z]{0,2}/i);
  return match ? match[0].split(' ')[0] : '';
}
